import * as types from 'store/modules/hres33u/mutation-types'
import hres33u from 'api/hres33u'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres33uLabels from 'assets/labels/hres33u'
import { hres33uColumns } from 'assets/columns/hres33u'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: {
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: false
    },
    labels: hres33uLabels,
    columns: hres33uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {
        tab1: {},
        tab2: {},
        tab3: {},
        tab4: {},
        tab5: {},
        tab6: {
          detail: {},
          table: {
            total: 0,
            rows: []
          }
        },
        tab7: {
          detail: {},
          table: {
            total: 0,
            rows: []
          }
        }
      },
      tab3: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab4: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab5: {},
      tab6: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES33U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES33U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES33U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES33U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES33U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES33U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES33U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES33U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES33U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES33U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].tab2Tab6Table = configLabel.replaceLabelToColumns(state.columns[keyLang].tab2Tab6Table, labels[keyLang])
        state.columns[keyLang].tab2Tab7Table = configLabel.replaceLabelToColumns(state.columns[keyLang].tab2Tab7Table, labels[keyLang])
        state.columns[keyLang].tab3Table1 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab3Table1, labels[keyLang])
        state.columns[keyLang].tab3Table2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab3Table2, labels[keyLang])
        state.columns[keyLang].tab4Table1 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab4Table1, labels[keyLang])
        state.columns[keyLang].tab4Table2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab4Table2, labels[keyLang])
        state.columns[keyLang].tab6Table1 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab6Table1, labels[keyLang])
        state.columns[keyLang].tab6Table2 = configLabel.replaceLabelToColumns(state.columns[keyLang].tab6Table2, labels[keyLang])
      }
    },
    [types.SET_HRES33U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES33U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES33U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES33U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES33U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = {
        tab1: false,
        tab2: false,
        tab3: false,
        tab4: false,
        tab5: false,
        tab6: false
      }
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail1':
          detailDisp.tab1 = true
          break
        case 'detail2':
          detailDisp.tab2 = true
          break
        case 'detail3':
          detailDisp.tab3 = true
          break
        case 'detail4':
          detailDisp.tab4 = true
          break
        case 'detail5':
          detailDisp.tab5 = true
          break
        case 'detail6':
          detailDisp.tab6 = true
          break
      }
      commit(types.SET_HRES33U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES33U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES33U_COLUMNS_LABELS] ({ commit }) {
      hres33u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES33U_COLUMNS, data.labels)
          commit(types.SET_HRES33U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES33U_INDEX] ({ commit }, searchParams) {
      hres33u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES33U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES33U_DETAIL] ({ commit }, typParam) {
      hres33u.getDetail(typParam)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES33U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES33U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres33u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES33U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres33u/index.js